<!--
 * @Author: your name
 * @Date: 2021-04-12 16:12:32
 * @LastEditTime: 2021-07-29 09:36:09
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ecfc-henan-oms-facade-SIT\src\components\EcSearch\src\search.vue
-->
<template>
  <div class="ec-search">
      <el-form
        ref="searchForm"
        size="small"
        :inline="true"
        @submit.native.prevent
        :label-position="labelPosition"
        :label-width="labelWidth"
        class="ec-search__form">
        <!--用于拓展搜索条件列表-->
          <template class="ec-search__content">
            <slot></slot>
          </template>
          <div class="ec-search__btns" ref="searchBtns" >
            <el-form-item v-show="advancedSearchShow">
              <el-button type="text" v-if="fold" @click="unfoldAllSearch" ref="advancedBtn" class="advancedBtn">全部展开<i class="el-icon-arrow-down"></i></el-button>
              <el-button type="text" v-else @click="initLayout" ref="advancedBtn" class="advancedBtn">全部收起<i class="el-icon-arrow-up"></i></el-button>
            </el-form-item>
            <el-form-item v-show="searchShow">
              <el-button type="primary" size="small" class="ec-button--primary" @click="search">搜索</el-button>
            </el-form-item>
            <el-form-item v-show="resetShow">
              <el-button class="ec-button--plain" size="small"  plain @click="resetSearch">重置</el-button>
            </el-form-item>
            <el-form-item v-show="exportShow">
              <el-button class="ec-button--plain" size="small" plain
              :disabled="exportDisabled" @click="exportExcel">导出</el-button>
            </el-form-item>
          </div>
      </el-form>
  </div>
</template>
<script>
import variables from '@/styles/theme/variables.scss'
export default {
  name: "EcSearch",
  props: {
    btnShow: {
      type: Boolean,
      default: true
    },
    check: {
      type: Boolean,
      default: true
    },
    searchProps: {
      type: Object,
      default: () => {
        return {}
      }
    } ,//定义搜索条件列表
    searchShow:{
      type:Boolean,
      default:true
    },
    resetShow:{
      type:Boolean,
      default:true
    },
    exportShow:{
      type:Boolean,
      default:false
    },
    exportDisabled:{
      type:Boolean,
      default:false
    },
    labelPosition: {
      type: String,
      default: 'right'
    },
    labelWidth: {
      type: String,
      default: '70px'
    }
  },
  computed: {
    variables () {
      return variables
    }
  },
  data() {
    return {
      fold: false,
      advancedSearchShow: false,
      pageData: {
        page: 1 //第几页
      },
      searchNum: 4,
      searchLength: 0,
      searchList: [],
      tempProps: {},
      firstSearch: true
    };
  },
  methods: {
    exportExcel(){
      this.$emit("exportExcel")
    },
    initLayout () {
      this.$nextTick(() => {
        if (!this.$refs.searchForm) {
          return 
        }
        let allChildren = this.$refs.searchForm.$el.children
        let allChildrenLen = allChildren.length
        let firstOffsetTop = allChildren[0].offsetTop

        let searchBtns =  this.$refs.searchBtns
        let searchBtnsOffsetTop = searchBtns.offsetTop
        // let secondOffsetTop = firstOffsetTop + Math.ceil(oneRowHeight)
        let secondOffsetTop = 0
        let isLastOk = 0
        // 查第二行的offsetTop
        for (let m = 0; m < allChildrenLen; m++) {
          if (firstOffsetTop < allChildren[m].offsetTop) {
            secondOffsetTop = allChildren[m].offsetTop
            break;
          }
        }
        for (let n = 0; n < allChildrenLen; n++) {
          if (secondOffsetTop < allChildren[n].offsetTop) {
            isLastOk = n
            break;
          }
        }
        // 如果是前两行，不动
        // console.log('secondOffsetTop >= searchBtnsOffsetTop:', isLastOk, secondOffsetTop, searchBtnsOffsetTop, secondOffsetTop >= searchBtnsOffsetTop)
        if (secondOffsetTop >= searchBtnsOffsetTop || isLastOk == allChildren - 1 ) {
          return
        }

        // 如果超出两行
        this.advancedSearchShow = true
        let searchBtnsClientWidth = searchBtns.clientWidth
        for (let i = 0; i < allChildrenLen - 1; i++) {
          if (secondOffsetTop < allChildren[i].offsetTop) {
            isLastOk = i
            break;
          }
        }
      //  console.log('isLastOk:', isLastOk)

        for (let k = isLastOk - 1; k >= 0; k--) {
          if (searchBtnsClientWidth <= 0) {
            isLastOk = k + 1
            break;
          }
          searchBtnsClientWidth -= (allChildren[k].clientWidth + 10)
          allChildren[k].style.display = 'none'
        }

        for (let j = isLastOk; j < allChildrenLen - 1; j++) {
          allChildren[j].style.display = 'none'
        }

        this.fold = true

      })

    },
    unfoldAllSearch () {
      this.$nextTick(() => {
        let allChildren = this.$refs.searchForm.$el.children
        let allChildrenLen = allChildren.length
        for (let i = 0; i < allChildrenLen - 1; i++) {
          allChildren[i].style.display = 'inline-block'
        }
        this.fold = false
      })
    },
    search () {
      const _this = this
      let searchPropsArr = [];
      searchPropsArr = _this.$EcSearchUtils.searchFormat(_this.tempProps);
      if(_this.searchShow){
        _this.$emit("search", searchPropsArr,this.pageData);
      }
      if(_this.firstSearch){
        _this.firstSearch = false
        _this.$emit("firstSearch");
      }
    },
    resetSearch () {
      let _this = this;
      _this.$emit("reset");
      //清空搜索条件 不重置标志resetValue
      for (let key in _this.tempProps) {
        if (_this.tempProps[key].resetValue !== 1) {
          _this.tempProps[key].value = null;
        }
      }
      let searchPropsArr = [];
      searchPropsArr = _this.$EcSearchUtils.searchFormat(_this.tempProps);
       if(_this.resetShow){
        _this.$emit("search", searchPropsArr,this.pageData);
       }
    }
  },
  mounted() {
    let _this = this;
    _this.tempProps = _this.searchProps;
    this.initLayout()
  }
};
</script>
<style scoped lang="scss">
@import '~@/styles/theme/variables.scss';
.ec-search {
  background: #FFFFFF;
  border: 1px solid #E4E4E4;
  border-radius: 3px;
  padding: 10px;
  margin-bottom: 10px;
  &__form {
    position: relative;
  }
  &__btns {
    display: inline-block;
    vertical-align: middle;
  }
  ::v-deep .el-form-item__label {
    padding-right: 8px;
  }
  ::v-deep .el-form--inline .el-form-item {
    margin-bottom: $searchItemMargin;
  }
  .ec-button {
    background: #FFFFFF;
    border: 1px solid $--color-primary;
    border-radius: 2px;
    font-size: 14px;
    color: $--color-primary;
    letter-spacing: 0;
    font-weight: 400;
    width: 80px;
    height: 32px;
  }
  .ec-button:hover {
      color: 0;
  }
  .advancedBtn {
    color: #999;
    font-size: $mediumFontSize;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EcSearch/src/search.vue